import callApi from "@repo/next-shared/utils/api";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { WishlistItem } from "@/types/wishlist";

async function getWishlist() {
  return await callApi({ path: "/catalog/wishlist", method: "GET" });
}

async function deleteWishlist(id: string) {
  return await callApi({ path: `/catalog/wishlist/${id}`, method: "DELETE" });
}

async function addWishlist(id: string) {
  return await callApi({
    path: "/catalog/wishlist",
    method: "POST",
    payload: { productId: id },
  });
}

export function useWishlistBase(select: any): any {
  return useQuery({
    queryKey: ["wishlist"],
    queryFn: () => getWishlist(),
    select,
  });
}

export function useDeleteWishlistBase(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteWishlist(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["wishlist"] });
    },
  });
}

export function useAddWishlistBase(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => addWishlist(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["wishlist"] });
    },
  });
}

export function useWishlist(): any {
  return useWishlistBase((wishlist: WishlistItem) => wishlist);
}

export function useDeleteWishlist(id: string): any {
  return useDeleteWishlistBase(id);
}

export function useAddWishlist(id: string): any {
  return useAddWishlistBase(id);
}
